<template>
    <div>
     <!-- OPTIONS -->
      <div class="shop-option-group option-group" :class="{disabled: disabledGroupOptionIds.findIndex(x => x == optionGroup.id) !== -1}" v-for="optionGroup in itemOptionGroups">
        <span>
          <strong>
            {{optionGroup.name}} 
            <span v-if="optionGroup.required" class="required red size18">*</span>
          </strong>
        </span><br>
        <div class="flex flex-wrap">
          <div v-for="option in optionGroup.options" class="xs-full">

            <div class="option-panel shop-option-panel">
              <div class="flex justify-between" @click="handleOptionClicked(option,optionGroup)">

                <div class="flex-1">

                  <label class="sr-only" :for="'option-'+option.id">{{option.name}}</label>
                  <input
                    v-if="!optionGroup.multipleOptions"
                    type="radio"
                    :checked="option.selected"
                    :name="'option-group-'+optionGroup.id"
                    :id="'option-'+option.id"
                    :disabled="disabledGroupOptionIds.findIndex(x => x == optionGroup.id) !== -1"
                    />
                  <input 
                    v-else
                    type="checkbox"
                    :checked="option.selected"
                    :id="'option-'+option.id"
                    :disabled="disabledGroupOptionIds.findIndex(x => x == optionGroup.id) !== -1"
                    />
                </div>

                <div class="xs-flex-5">
                  <span>
                  {{option.name}}
                  </span>
                </div>
                <div class="flex-1 option-price">
                <strong>
                  {{option.price}} {{currency}}
                </strong>
                </div>

              </div>
            </div>

          </div>
          
        </div>
      </div>

      <!-- COMMENTS -->
      <div v-if="item.enable_comments" class="padd30t padd30b">

        <label>
          <span class="sr-only">{{__t('shop.product.comments')}}</span>
          <textarea v-model="comments" class="comment-textarea shop-item-comments" name="" id="" cols="30" rows="10" :placeholder="__t('shop.product.comments')"></textarea>
        </label>
      </div>
    </div>
</template>
<script>


import cartService from '@/services/cart';

export default {
    components: {},
    data: function(){
        return {
          itemOptionGroups: [],
          comments: '',
          currency: window.currency,
        }
    },
    props:{
      variant: Object,
      totalCost: [String,Number],
      type: {default: 'add',type: String},
      quantity: Number,
      item: Object,
      bus: Object,
      discPrice: [String,Number],
    },
    computed:{
      disabledGroupOptionIds(){
        return this.$_.flatMap(this.selectedOptions,'groupRestrictionIds');
      },
      allOptions(){
        return this.$_.flatMap(this.itemOptionGroups,'options');
      },
      selectedOptions(){
        // get all options that are selected and that their
        // option group is not disabled
        return this.allOptions.filter(x => x.selected);
      },
    },
    methods:{
      // public methods
      get(){
        var options = this.selectedOptions.filter(x => !this.disabledGroupOptionIds.includes(x.optionGroupId));

        return {
          item:this.item,
          comments: this.comments,
          options,
          quantity: this.quantity
        }
      },
      init(){
        this.initOptions(this.item);
      },
      // END PUBLIC METHODS
      isDisabled(optionGroup){
        return this.disabledGroupOptionIds.findIndex(x => x == optionGroup.id) !== -1
      },
      costChanged(){

        var sum = 0;
        if(!this.item) return sum;

        sum = cartService.itemTotal({
          quantity: this.quantity,
          price: this.discPrice,
          variant: this.variant,
          options: this.selectedOptions
        },this.discPrice);

        this.$emit('cost-changed',sum.toFixed(2))
      },
      handleOptionClicked(option,optionGroup){

        if(this.isDisabled(optionGroup)) return;

        this.itemOptionGroups = [...this.itemOptionGroups.map(optGroup => {
          optGroup.options = optGroup.options.map(opt => {
            if(optGroup.id == optionGroup.id){

              // handle radio button
              if(!optGroup.multipleOptions){
                opt.selected = false;
                if(opt.id == option.id){
                  opt.selected = true
                }
              }else{
                if(opt.id == option.id){
                opt.selected = !opt.selected;
                }
              }
            }
            return opt;
          });
          return optGroup;
        })];

        this.costChanged();
      },
      initOptions(item){
        $.getJSON(route('webapp.ordering.item.option-groups',{alias:window.company_alias,item: item.id}),(response) => {
          var optionGroups = response.data;

          this.itemOptionGroups = optionGroups.map(optionGroup => {
            optionGroup.options = optionGroup.options.map(option => {
              option.optionGroup = optionGroup;
              if(this.type == 'add'){
                option.selected = !!option.preSelected;
              }else{
                option.selected = this.item.options.findIndex(x => x.id == option.id) !== -1 ? true : false;
              }
              return option;
            });

            // if it's a radio choice and none
            // is selected, just select the first
            if(
              !optionGroup.multipleOptions &&
              optionGroup.options.filter(x => x.selected).length == 0
            )
            {
              if (optionGroup.options.length > 0)
                  optionGroup.options[0].selected = true;
            }

            return optionGroup;
          });


          this.costChanged();

        });
      }
    },
    watch:{
      quantity(value){
        this.costChanged();
      },
      variant(value){
        this.costChanged();
      },
      item:{
        handler(val){
          if(val && val.id){
            this.initOptions(val);
          }
        },
        deep:true
      }
    },
    mounted(){

      this.bus.$on('submit', () =>  this.$emit('get:item',this.get()))

      if(this.item && this.item.id){
        this.initOptions(this.item);
      }
    }
}
</script>

<style scoped>
.option-price{
  min-width: 48px;
}
.option-panel > div > * {
  margin:0px 4px;
}

.option-panel:hover{
  cursor: pointer;
}

.option-group.disabled{
  display: none;
}
.option-group.disabled .option-panel{
  background-color: gray;
}

.option-group.disabled .option-panel:hover{
  cursor:not-allowed;
}

.option-panel{
  border-radius: 4px;
  margin: 6px;
  padding: 10px 12px;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,.13);
  min-width: 120px;
  font-size: 12px;
}

textarea{
  resize: vertical;
  width: 100%;
  font-size: 15px;
  min-height:55px;
  text-indent: 22px;
  width: 100%;
  height: 36px;
  padding: 6px 12px;
  background-color: #fff;
  border: 1px solid #ccd0d2;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
  -webkit-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
}
</style>
